// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3pWWF","buttons":"RemoveExpirationActionButtons_buttons__7quI6"};